<template>
  <div id="app">
    <header class="title" :class="isScrolled ? 'color-w' : ''">
      <div class="title-left">
        <img src="@/assets/logo.png" class="logo" />
        <span>Lumi</span>
      </div>
      <div class="mens">
        <div
          v-for="(item, index) in menu"
          :key="index"
          :style="routeIndex === index ? 'color: #1b67c8;' : ''"
          @click="menuChange(index, item.router)"
        >
          {{ item.title }}
        </div>
      </div>
    </header>

    <RouterView></RouterView>

    <footer class="footer">
      <div style="display: flex">
        <div style="flex: 1">
          <div class="c-name">Zoriona, S.A. de C.V., SOFOM, E.N.R.</div>
          <div class="c-title">Dirección de empresa</div>
          <div class="c-desc">
            AVENIDA ROBLE 555 PISO 4, VALLE DEL CAMPESTRE, SAN PEDRO GARZA
            GARCIA, NUEVO LEON 66265 MEXICO
          </div>

          <div class="c-title">Servicio al cliente email</div>
          <div class="c-desc">servicio@zorionasofom.com</div>
          <div class="c-title">Teléfono de atención</div>
          <div class="c-desc">+52 5573628956</div>
        </div>
        <div class="Uso-box">
          <div class="Uso" @click="toT(0)">Términos de Uso</div>
          <div class="Uso" @click="toT(1)">Acuerdo de Privacidad</div>
        </div>
      </div>
      <div class="todos" style="text-align: center">
        © Todos los derechos reservados © Zoriona, S.A. de C.V.
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',

  data() {
    return {
      routeIndex: 0,
      menu: [
        {
          title: 'Inicio',
          router: '/',
        },
        {
          title: 'Calificación de la empresa',
          router: '/Nosotros',
        },
        {
          title: 'Eliminar cuenta',
          router: '/Cuenta',
        },
        {
          title: 'Acuerdo de Privacidad',
          router: '/Acuerdo',
        },
      ],
      isScrolled: false,
    };
  },
  created() {
    const path = this.$route.path;
    if (path === '/') {
      this.routeIndex = 0;
    } else if (path === '/Nosotros') {
      this.routeIndex = 1;
    } else if (path === '/Cuenta') {
      this.routeIndex = 2;
    } else if (path === '/Acuerdo') {
      this.routeIndex = 3;
    } else {
      this.routeIndex = null;
    }
  },
  mounted() {
    // 监听滚动事件
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动事件监听器（避免内存泄漏）
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      // 获取页面滚动的距离
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      // 判断是否滚动超过 100px
      if (scrollTop > 50) {
        this.isScrolled = true; // 已滚动超过 100px
      } else {
        this.isScrolled = false; // 尚未滚动超过 100px
      }
    },
    menuChange(index, name) {
      this.routeIndex = index;
      this.$router.push({ path: name });
      this.scrollToTop();
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'instant',
      });
    },
    toT(state) {
      if (state === 0) {
        this.routeIndex = null;
        this.$router.push({ path: '/Terminos' });
        this.scrollToTop();
      } else {
        this.routeIndex = 3;
        this.$router.push({ path: '/Acuerdo' });
        this.scrollToTop();
      }
    },
  },
};
</script>

<style scoped>
.title-left {
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #1b67c8;
}
.mens {
  display: flex;
  gap: 70px;
  font-size: 16px;
}
.mens div {
  cursor: pointer;
  font-weight: bold;
}
.title {
  height: 70px;
  line-height: 70px;
  padding: 0 360px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 20px;
  position: sticky;
  top: 0;
  z-index: 99999;
}

.footer {
  background: white;
  font-size: 14px;
  color: #1b67c8;
  padding: 22px 360px;
}
.c-title {
  font-size: 18px;
  margin-bottom: 5px;
  font-weight: bold;
}
.Uso-box {
  flex: 1;
  padding-left: 20%;
}
.Uso {
  font-size: 18px;
  margin-bottom: 5px;
  text-decoration: underline;
  cursor: pointer;
  margin-bottom: 20px;
}
.c-desc {
  margin-bottom: 20px;
  font-size: 16px;
}

.logo {
  width: 44px;
  height: 44px;
  margin-right: 16px;
}
.color-w {
  background-color: #9dbde7;
}
.c-name {
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: bold;
}
.todos {
  font-size: 16px;
}
@media (max-width: 768px) {
  .title {
    display: none;
  }
  .footer {
    display: none;
  }
  .Notmex {
    display: none;
  }
}
</style>
